export const stravaConfig = {
    clientId: process.env.REACT_APP_STRAVA_CLIENT_ID as string,
}